import React from "react";
import { VideoJs } from "./VideoJs";

export default function VideoPreview(props: any) {
    const { footage, playbackRate } = props;
    const [options, setOptions] = React.useState({
        sources: [footage.timelapse_url],
        loop: true,
        autoplay: false,
        // width: 346,
        // height: 184,
        controls: true,
        playbackRates: [0, 0.25, 0.5 , 1],
        playbackRate: parseFloat(playbackRate) ?? 0.5,
        defaultPlaybackRate: parseFloat(playbackRate) ?? 0.5,
        image: footage.thumbnail_url,
        fluid: true,
        // aspectRatio: '3:4',
        responsive: false,
        // height: 240,
        // width: '100%',
        aspectRation: '320:240',
        controlBar: {
            children: [
                'playToggle',
                'progressControl',
                'fullscreenToggle',
                'playbackRateMenuButton',
                // No 'volumePanel' or 'volumeControl'
            ],
        },
    });

    function playTimelapse(e) {
        //   setIsPlaying(true);
        setOptions({
            ...options,
            autoplay: true,
        });
    }

    function stopTimelapse(e) {
        // setIsPlaying(false);
        setOptions({
            ...options,
            autoplay: false,
        });
    }

    return (
        <div onMouseEnter={(e) => playTimelapse(e)} onMouseLeave={(e) => stopTimelapse(e)}>
            {/* {footage.thumbnail_url && !isPlaying && (
              <img className="thumbnail" src={footage.thumbnail_url} />
          )} */}
            {/* {!footage.thumbnail_url && !isPlaying && (<div>
              TIMELAPSE ONLY
          </div>)} */}
            <VideoJs options={options} />
        </div>
    );
}
